import { createModel } from "hox";
import useGlobalModel from "@/model/globalModel";

export type supplierMapType = {
    code: string,
    idx: string
    name: string
    fullName: string
}

export const supplierMapModel = createModel(function () {
    const { supplieAllList } = useGlobalModel();

    const supplierMap: supplierMapType[] = supplieAllList.filter((e: any) => e.typeCode != "supplier-type.company-internal")
        .map((e: any) => {
            return { code: e.code, idx: e.userCode, name: e.note, fullName: e.name }
        });

    /**
     * 根据指定字段查询供应商信息
     * @param filterField 搜索字段（必须是 supplierMapType 的键）
     * @param filterValue 搜索字段的对应值
     * @param targetField 要返回的目标字段
     * @returns 匹配记录的目标字段值，未找到时返回空字符串
     */
    function getSupplierField<K extends keyof supplierMapType>(
        filterField: K,
        filterValue: supplierMapType[K],
        targetField: keyof supplierMapType,
        source?: supplierMapType[],
    ): string {
        const record = (source ?? supplierMap).find(item => item[filterField] === filterValue);
        return record?.[targetField] ?? '';
    }

    return { supplierMap, getSupplierField };

})



